import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"],
  _excluded2 = ["data"],
  _excluded3 = ["data"];
/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.SelfServePublicRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import { useQuery, useLazyQuery, useSuspenseQuery } from 'data-fetching-client';
import * as Queries from './SelfServePublicRpc.dfc.new';
export function useGetAllPublishedCollectionsQuery(options) {
  const _useQuery = useQuery(Queries.GET_ALL_PUBLISHED_COLLECTIONS_QUERY, options),
    {
      data
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAllPublishedCollections: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetAllPublishedCollectionsLazyQuery(options) {
  const [getter, _ref] = useLazyQuery(Queries.GET_ALL_PUBLISHED_COLLECTIONS_QUERY, options);
  const {
      data
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded2);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAllPublishedCollections: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetAllPublishedCollectionsSuspenseQuery(options) {
  const _useSuspenseQuery = useSuspenseQuery(Queries.GET_ALL_PUBLISHED_COLLECTIONS_QUERY, options),
    {
      data
    } = _useSuspenseQuery,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery, _excluded3);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAllPublishedCollections: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}